import React from 'react'
import CustomerList from './CustomerList';


export default function Achivment() {
  const stats = [
    { value: "Real-Time Analytics ", label: "Actionable insights and live data dashboards that help you make smarter, faster business decisions." },
    { value: "Smart KYC Verification ", label: "Automated identity verification that reduces onboarding time and ensures full regulatory compliance." },
    { value: "Instant Loan Processing ", label: "End-to-end digital loan origination that cuts approval time from days to minutes." },
    { value: "Seamless API Integration ", label: "Plug-and-play APIs that connect effortlessly with your existing systems and third-party platforms." },
    { value: "Multi-Channel Support ", label: "Deliver consistent lending experiences across web, mobile, and app platforms without extra effort." },
    { value: "Cloud-Native Platform ", label: "Fully hosted on secure cloud infrastructure ensuring maximum uptime, speed, and reliability." },
    ];

  return (
    <section className="relative overflow-hidden bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-100 py-20 px-4">
      <div className="max-w-7xl mx-auto grid lg:grid-cols-1 gap-12 items-center">

        {/* LEFT */}
        <div className="animate-fadeInUp">
          <p className='text-[#00bd86] font-semibold'>Why LNVS Fintech?</p>
          <h4 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900 leading-snug mb-4">
            Intelligent Technology Built for the Future of Lending
          </h4>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
            {stats.map((item, index) => (
              <div key={index} className="flex gap-5 animate-fadeUp mt-10"
                style={{ animationDelay: `${index * 0.2}s` }}>
                <div className="w-[2px] bg-gradient-to-b from-[#00bd86] to-transparent"></div>

                <div className='pt-2'>
                  <h2 className="text-2xl sm:text-2xl font-semibold text-[#172f47]">
                    {item.value}
                  </h2>
                  <p className="text-gray-600 text-sm sm:text-base pt-2">
                    {item.label}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* RIGHT */}

        {/* <CustomerList/> */}

        {/* <h3>We Mudra</h3> */}


      </div>

      {/* ANIMATIONS */}
      <style>{`
        @keyframes fadeInUp {
          from {opacity:0; transform:translateY(40px);}
          to {opacity:1; transform:translateY(0);}
        }

        @keyframes fadeUp {
          from {opacity:0; transform:translateY(30px);}
          to {opacity:1; transform:translateY(0);}
        }

        .animate-fadeInUp {
          animation: fadeInUp 0.8s ease forwards;
        }

        .animate-fadeUp {
          opacity: 0;
          animation: fadeUp 0.8s ease forwards;
        }
      `}</style>
    </section>
  )
}
